<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Terms &amp; Conditions" />
    </template>
    <p>
      TBC
    </p>
  </base-content>
</template>

<script>
import HeroHeader from '@/components/HeroHeader.vue'

export default {
  components: {
    HeroHeader
  }
}
</script>
